module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_8019.7b9453e9.png";